import { FaMapMarkerAlt } from "react-icons/fa";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Layout2 from "../../Layouts/Layout2";

export const TopBar = ({ PropertyData }) => {
  const navigate = useNavigate();
  return (
    <>
      <Layout2 className="mt-8 px-5">
        <div className="group inline-flex items-center text-[#097FE6] font-medium cursor-pointer transition-all duration-200 hover:text-blue-700">
          <ChevronLeft
            size={20}
            className="transition-transform duration-200 group-hover:-translate-x-1"
          />
          <div className="ml-1 relative" onClick={() => navigate(-1)}>
            Back to results
            <span className="absolute left-0 -bottom-0.5 w-0 h-[1px] bg-blue-700 transition-all duration-200 group-hover:w-full"></span>
          </div>
        </div>

        {/* ||---------- Breadcrumb Section ----------|| */}
        <div className="my-5 sm:my-6">
          <div className="flex items-center flex-wrap gap-3 text-[12px] xs:text-xs sm:text-sm md:text-base">
            {/* Status */}
            <span className="text-gray-400 font-medium">
              {PropertyData?.status === "active"
                ? "Buy"
                : PropertyData?.status?.charAt(0).toUpperCase() +
                PropertyData?.status?.slice(1)}
            </span>

            {/* Separator */}
            {(PropertyData?.municipality ||
              PropertyData?.suburb ||
              PropertyData?.street_address_name ||
              PropertyData?.street_address_number) && (
                <span className="text-gray-400">/</span>
              )}

            {/* Municipality */}
            {PropertyData?.municipality && (
              <>
                <span className="text-gray-400 font-medium hover:text-gray-900 transition-colors duration-200">
                  {PropertyData.municipality}
                </span>
                {(PropertyData?.suburb ||
                  PropertyData?.street_address_name ||
                  PropertyData?.street_address_number) && (
                    <span className="text-gray-400">/</span>
                  )}
              </>
            )}

            {/* Suburb */}
            {PropertyData?.suburb && (
              <>
                <span className="text-gray-400 font-medium hover:text-gray-900 transition-colors duration-200">
                  {PropertyData.suburb}
                </span>
                {(PropertyData?.street_address_name ||
                  PropertyData?.street_address_number) && (
                    <span className="text-gray-400">/</span>
                  )}
              </>
            )}

            {/* Street address */}
            {(PropertyData?.street_address_name ||
              PropertyData?.street_address_number) && (
                <span className="text-black font-medium flex items-center gap-1.5">
                  <FaMapMarkerAlt className="text-[#097FE6] text-[15px] flex-shrink-0" />
                  <span className="break-words">
                    {PropertyData?.street_address_name}{" "}
                    {PropertyData?.street_address_number}
                  </span>
                </span>
              )}
          </div>
        </div>
      </Layout2>
    </>
  );
};
